exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-56a77f90]{padding-left:0;display:flex;flex-flow:row wrap}li[data-v-56a77f90]{list-style-type:none;padding:10px;transition:all .3s ease}.card[data-v-56a77f90]{display:block;width:230px;height:230px;padding-top:35px;border-radius:7px;text-align:center;line-height:27px;cursor:pointer;color:#fff;font-weight:600;font-size:20px;-webkit-box-shadow:9px 10px 22px -8px rgba(209,193,209,.5);-moz-box-shadow:9px 10px 22px -8px rgba(209,193,209,.5);box-shadow:9px 10px 22px -8px rgba(209,193,209,.5);background-color:#302f30;will-change:transform;animation:match-keyframes-data-v-56a77f90 5s ease-out;z-index:5;position:absolute;top:40%;left:50%;margin-top:-115px;margin-left:-115px}@keyframes match-keyframes-data-v-56a77f90{0%{transform:scale(0)}50%{transform:scale(3)}to{transform:scale(3)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56a77f90","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app-card-matched.vue
// module id = 146
// module chunks = 0